export default "./media/marker_offline-ad5573f9e2aadf45a915ec4b986ede80.png";